module.exports = __webpack_public_path__ + "94f420811cdcb9fe99dc0b1f48af8f62.jpg";